import { render, staticRenderFns } from "./OrderAppeal.vue?vue&type=template&id=655b46b2&scoped=true&"
import script from "./OrderAppeal.vue?vue&type=script&lang=js&"
export * from "./OrderAppeal.vue?vue&type=script&lang=js&"
import style0 from "./OrderAppeal.vue?vue&type=style&index=0&id=655b46b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "655b46b2",
  null
  
)

export default component.exports